import React from 'react';
import {useCheckout} from "../../../Providers/CheckoutProvider";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import {Trans} from "react-i18next";

export default ({onClose, ...other}) => {
  const { getTermsOfPurchase } = useCheckout();

  return <Dialog
    maxWidth="xs"
    aria-labelledby="confirmation-dialog-title"
    open={open}
    onClose={onClose}
    {...other}
  >
    <DialogTitle id="confirmation-dialog-title">
      <Trans>Terms of purchase</Trans>
    </DialogTitle>
    <DialogContent dividers>
      <p>{getTermsOfPurchase().split("\n").map((line, idx) => <React.Fragment key={idx}>{line}<br /></React.Fragment>)}</p>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        <Trans>Ok</Trans>
      </Button>
    </DialogActions>
  </Dialog>
}